import React, { FC, useEffect, useState } from "react";
import { mergeStyles, mergeStyleSets } from "office-ui-fabric-react";
import { useHistory } from "react-router";
import { Nomination } from "../../models";
import SofIcon from "../common/Icons";
import { toNominationNo } from "../../services/Helper";

type Props = {
  nomination: Nomination;
  onClick(nom: Nomination): void;
};
const text = mergeStyles({
  color: "var(--grey-800)",
  fontSize: 14,
  lineHeight: 20,
  fontWeight: "normal"
});
const classes = mergeStyleSets({
  container: {
    border: "1px solid #E2E6E8",
    padding: 10,
    margin: "0 0 10px 0",
    display: "flex",
    width: "100%",
    alignItems: "center",
    cursor: "pointer",
    selectors: {
      [":active"]: {
        backgroundColor: "#88CEFF"
      }
    }
  },
  icon: {
    width: 70,
    height: 70,
    marginRight: 10,
    color: "#FFFFFF",
    textAlign: "center",
    fontSize: 12,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  iconSvg: {
    marginLeft: "auto",
    marginRight: "auto"
  },
  centerContainer: {
    flex: "1 1 auto"
  },
  textFieldValue: [
    text,
    {
      fontWeight: "bold"
    }
  ],
  textField: [text],
  bottomRow: {
    display: "flex"
  },
  bottomRowItem: {
    // flex: "1 1 auto"
    marginRight: "20px"
  }
});

const NominationTile: FC<Props> = (props: Props) => {
  const [shortNominationNo, setShortNominationNo] = useState("");
  const history = useHistory();

  const onClick = () => {
    const { lineHandlingNo, nominationNo } = props.nomination;
    props.onClick(props.nomination);
    history.push(`/marine/${lineHandlingNo}/sof?nomination=${nominationNo}`);
  };

  const getIconClass = () => {
      let iconColor = "#00447E";
      if (props.nomination.status === 1) {
          iconColor = "#1890FF";
      } else if (props.nomination.status === 2) {
          iconColor = "#4CAF50";
      }
    return mergeStyles(classes.icon, { backgroundColor: iconColor });
  };

  useEffect(() => {
    const nomNo = toNominationNo(props.nomination);
    if (nomNo) setShortNominationNo(nomNo);
  }, [props.nomination]);

  return (
    <div
      id={`btn-${props.nomination.nominationNo}`}
      className={classes.container}
      onClick={onClick}
    >
      <div>
        <div className={getIconClass()}>
          <SofIcon
            className={classes.iconSvg}
            iconname={props.nomination.nominationType}
          />
          {props.nomination.nominationType}
        </div>
      </div>
      <div className={classes.centerContainer}>
        <span className={classes.textFieldValue}>
          {shortNominationNo} - {props.nomination.product}
        </span>
        <br />
        <span className={classes.textField}>{props.nomination.customer}</span>
        <br />
        <div className={classes.bottomRow}>
          <div className={classes.bottomRowItem}>
            <span className={classes.textField}>Tank</span>&nbsp;
            <span className={classes.textFieldValue}>
              {props.nomination.tank}
            </span>
          </div>
          <div className={classes.bottomRowItem}>
            <span className={classes.textField}>Qty</span>&nbsp;
            <span className={classes.textFieldValue}>
              {Number(props.nomination.quantity).toFixed(2)}
            </span>
          </div>
        </div>
      </div>
      <div>
        <SofIcon iconname="Forward" />
      </div>
    </div>
  );
};

export default NominationTile;
